import { motion, AnimatePresence } from 'framer-motion';
import type { PdvDestaqueItem } from '@/shared/types';
import { montarTextoDestaque } from '../../domain/usecases/textoDestaque';

const SHADOW = '0 8px 40px rgba(0,0,0,0.45), 0 0 28px rgba(251,146,60,0.10), inset 0 1px 0 rgba(255,255,255,0.14)';

interface Props {
  /** null = escondido */
  itens: PdvDestaqueItem[] | null;
}

/**
 * Card de novo pedido — canto superior direito da coluna de vídeo, abaixo do
 * ponto de conexão, deslizando da direita. Vive dentro do PlayerContent para
 * ficar à esquerda da Ads sidebar quando o L-bar está aberto; não ocupa o
 * rodapé (RAIO-X/ticker/HUD) nem o topo central (pedido do cliente/tocando agora).
 */
export default function TvPdvDestaqueCard({ itens }: Props) {
  const texto = itens && itens.length > 0 ? montarTextoDestaque(itens) : null;
  return (
    <div className="absolute right-4 top-12 z-[9] pointer-events-none select-none max-w-[min(34vw,520px)]" aria-live="polite">
      <AnimatePresence>
        {texto && (
          <motion.div
            key={texto.titulo}
            className="flex items-center gap-3 rounded-2xl border border-white/[0.12] px-4 py-3 backdrop-blur-[20px]"
            style={{ background: 'linear-gradient(160deg, rgba(28,28,36,0.62) 0%, rgba(6,8,16,0.48) 100%)', boxShadow: SHADOW }}
            initial={{ opacity: 0, x: 48 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 48 }}
            transition={{ duration: 0.4, ease: 'easeOut' }}
          >
            {texto.video_url ? (
              <video src={texto.video_url} muted autoPlay loop playsInline aria-hidden="true" className="h-[clamp(44px,5vw,88px)] w-[clamp(44px,5vw,88px)] shrink-0 rounded-xl object-cover ring-2 ring-orange-400/50" />
            ) : texto.imagem_url ? (
              <img
                src={texto.imagem_url}
                alt=""
                className="h-[clamp(44px,5vw,88px)] w-[clamp(44px,5vw,88px)] shrink-0 rounded-xl object-cover ring-2 ring-orange-400/50"
              />
            ) : (
              <div className="flex h-[clamp(44px,5vw,88px)] w-[clamp(44px,5vw,88px)] shrink-0 items-center justify-center rounded-xl bg-orange-500/15 text-[clamp(20px,2.2vw,40px)]">
                🍖
              </div>
            )}
            <div className="min-w-0">
              <p className="text-[clamp(9px,0.7vw,11px)] font-semibold uppercase tracking-[0.2em] text-orange-300/80">
                Novo pedido na mesa
              </p>
              <p className="mt-0.5 line-clamp-2 text-[clamp(14px,1.35vw,24px)] font-bold leading-tight text-white">
                {texto.titulo}
              </p>
              {texto.subtitulo && (
                <p className="mt-0.5 line-clamp-1 text-[clamp(10px,0.85vw,14px)] text-white/65">{texto.subtitulo}</p>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
